module.exports = __webpack_public_path__ + "static/media/janio-sticker-logo.b69cf1f0.png";